if (!customElements.get('couchery-product-configurator')) {
  customElements.define('couchery-product-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('.lf-config-data').textContent);
      this.values = {};
      this.controls = {};
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD', currencyDisplay:'code', minimumFractionDigits:0, maximumFractionDigits:2}).format(value / 100);
      const container = this.querySelector('.lf-config');
      for (const set of this.config.sets || []) {
        const label = document.createElement('label'); label.className = 'co-field';
        const name = document.createElement('span'); name.textContent = set.label + (set.required ? ' *' : '');
        const control = document.createElement(set.input === 'text' ? 'textarea' : 'select');
        control.dataset.setId = set.id; control.required = Boolean(set.required);
        if (set.input === 'text') { control.maxLength = 300; control.rows = 2; }
        else {
          if (!set.required || !set.default) { const blank = document.createElement('option'); blank.value = ''; blank.textContent = this.dataset.chooseLabel || 'Choose an option'; control.append(blank); }
          for (const choice of set.choices || []) {
            const option = document.createElement('option'); option.value = choice.id;
            option.textContent = choice.label + (choice.paid && Number.isInteger(choice.price) ? ' (+' + this.money(choice.price) + ')' : ''); control.append(option);
          }
          control.value = set.default || '';
        }
        this.values[set.id] = control.value; this.controls[set.id] = control;
        control.addEventListener('input', () => { this.values[set.id] = control.value; this.querySelector('.co-cart-review').hidden = true; this.updatePrice(); });
        control.addEventListener('change', () => { this.values[set.id] = control.value; this.querySelector('.co-cart-review').hidden = true; this.updatePrice(); });
        label.append(name, control);
        if (set.help) { const help = document.createElement('small'); help.textContent = set.help; label.append(help); }
        container.append(label);
      }
      this.quantity = this.querySelector('.co-qty');
      this.quantity.addEventListener('input', () => { this.querySelector('.co-cart-review').hidden = true; this.updatePrice(); });
      this.add = this.querySelector('.co-add');
      if (this.dataset.preview !== 'true') this.add.textContent = this.dataset.addLabel || 'Add configured sofa to cart';
      this.add.addEventListener('click', () => this.addConfiguration());
      const raw = JSON.parse(this.querySelector('.lf-data').textContent);
      this.rows = raw.map(CoucheryMaterials.classicRow);
      this.groups = CoucheryMaterials.groups(this.rows);

      this.materials = this.querySelector('.lf-materials');
      this.grid = this.querySelector('.lf-swatches');
      this.search = this.querySelector('input[type=search]');
      this.hero = this.querySelector('.lf-hero');
      this.dialog = this.querySelector('dialog');
      this.groups.forEach(group => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lf-material';
        button.dataset.material = group;
        CoucheryMaterials.decorate(this, button, group, this.rows.filter(row => row.material === group).length);
        button.addEventListener('click', () => {
          this.search.value = '';
          this.select(this.rows.find(row => row.material === group));
        });
        this.materials.append(button);
      });
      this.search.addEventListener('input', () => this.renderSwatches());
      this.querySelector('.lf-zoom').addEventListener('click', () => {
        if (!this.current.image) return;
        const image = this.dialog.querySelector('img');
        image.src = ['Performance Diamond', 'Premium Natural', 'Loft Bouclé', 'Velour Suede', 'Cloudsoft Weave'].includes(this.current.material) ? this.current.image : this.current.swatch || this.current.image;
        image.alt = this.current.name;
        this.dialog.querySelector('p').textContent = this.current.colour + ' · ' + this.current.material;
        this.dialog.showModal();
      });
      const makeActualSwatch = parent => {
        const figure = document.createElement('figure'); figure.className = 'lf-loft-swatch'; figure.hidden = true;
        const photo = document.createElement('img'); photo.width = 180; photo.height = 180; photo.loading = 'lazy';
        const caption = document.createElement('figcaption'); caption.textContent = 'Actual fabric'; figure.append(photo, caption); parent.append(figure); return figure;
      };
      this.actualSwatches = [makeActualSwatch(this.querySelector('.lf-stage')), makeActualSwatch(this.dialog)];
      this.querySelector('.lf-visual').addEventListener('click', event => {
        if (event.target.closest('.cch-gal')) this.actualSwatches.forEach(figure => { figure.hidden = true; });
      }, true);
      this.querySelector('.lf-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      const id = new URL(location.href).searchParams.get('variant') || this.dataset.initialVariant;
      this.select(this.rows.find(row => row.id === id) || this.rows[0], false);
    }
    select(row, updateUrl = true) {
      if (!row) return;
      this.current = row;
      CoucheryMaterials.update(this, row, this.rows);
      const logo = this.querySelector('.lf-stage-label');
      if (logo) logo.hidden = ['Performance Diamond', 'Premium Natural', 'Loft Bouclé', 'Velour Suede', 'Cloudsoft Weave'].includes(row.material);
      this.querySelector('.co-cart-review').hidden = true;
      this.updatePrice();
      this.materials.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.material === row.material)));
      this.hero.hidden = !row.image;
      this.querySelector('.lf-image-status').hidden = Boolean(row.image);
      this.hero.onerror = () => { this.hero.hidden = true; this.querySelector('.lf-image-status').hidden = false; };
      if (row.image) this.hero.src = row.image;
      this.actualSwatches?.forEach(figure => {
        const show = ['Loft Bouclé', 'Velour Suede', 'Cloudsoft Weave'].includes(row.material) && Boolean(row.swatch); figure.hidden = !show;
        if (show) { const photo = figure.querySelector('img'); const source = new URL(row.swatch, location.origin); source.searchParams.set('width', '400'); photo.src = source.href; photo.alt = 'Actual '+row.material+' '+row.colour + ' ' + row.code + ' fabric photograph'; }
      });
      this.hero.alt = row.name;
      this.querySelector('.lf-selected-name').textContent = row.colour;
      this.querySelector('.lf-selected-material').textContent = CoucheryMaterials.label(this, row.material) + (row.code ? ' · ' + row.code : '');
      this.querySelector('.lf-detail-name').textContent = row.colour;
      this.querySelector('.lf-code').textContent = row.code;
      this.querySelector('.lf-code').hidden = !row.code;
      this.querySelector('.lf-description').textContent = row.description || '';
      this.querySelector('.lf-description').hidden = !row.description || row.description === this.querySelector('.lf-material-help')?.textContent;
      this.querySelector('.lf-composition').textContent = row.composition || '';
      this.querySelector('.lf-care').textContent = row.care || '';
      this.querySelector('.lf-composition').closest('details').hidden = !row.composition;
      this.querySelector('.lf-care').closest('details').hidden = !row.care;
      const tags = this.querySelector('.lf-tags');
      tags.replaceChildren();
      (row.tags || []).forEach(value => { const tag = document.createElement('span'); tag.className = 'lf-tag'; tag.textContent = value.trim(); tags.append(tag); });
      this.querySelector('.lf-zoom').disabled = !row.image;
      this.renderSwatches();
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', row.id); history.replaceState(null, '', url); }
    }
    updatePrice() {
      if (!this.current) return;
      const selected = CoucheryOptions.selection(this.config, this.values);
      const valid = Number.isInteger(this.current.price) && this.current.price > 0 && !selected.errors.some(error => error.includes('not ready'));
      const quantity = Number(this.quantity.value);
      const price = this.querySelector('.lf-price');
      price.textContent = valid ? this.money((this.current.price + selected.surcharge) * (Number.isInteger(quantity) && quantity > 0 ? quantity : 1)) : price.dataset.pending;
      price.classList.toggle('is-pending', !valid);
      const context = this.querySelector('.lf-price-context');
      context.textContent = this.dataset.preview === 'true' ? this.dataset.previewContext : context.dataset.priced;
      this.querySelector('.lf-breakdown').textContent = valid ? [this.dataset.baseLabel + ' ' + this.money(CoucheryMaterials.base(this.rows)), ...(CoucheryMaterials.surcharge(this.rows, this.current) > 0 ? [JSON.parse(this.querySelector('.sofa-material-pricing-copy').textContent).material + ' +' + this.money(CoucheryMaterials.surcharge(this.rows, this.current))] : []), ...selected.chosen.map(({set,choice}) => set.label + ' +' + this.money(choice.paid && Number.isInteger(choice.price) ? choice.price : 0))].join(' · ') : '';
      this.querySelector('.co-message').textContent = selected.errors.join(' ');
      const subject = this.dataset.productTitle + ' / ' + this.current.name + ' / ' + Object.values(selected.properties).join(' / ');
      this.querySelector('.lf-contact').href = 'mailto:hello@couchery.com?subject=' + encodeURIComponent(subject);
      this.configSelection = selected;
      if (this.dataset.preview !== 'true' && !this.busy) {
        const unavailable = !this.current.available || selected.chosen.some(({choice}) => choice.paid && !choice.available);
        this.add.disabled = unavailable;
        if (unavailable) this.querySelector('.co-message').textContent = this.dataset.unavailableLabel;
      }
    }
    async addConfiguration() {
      if (this.busy) return;
      const preview = this.dataset.preview === 'true';
      const group = crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      const built = CoucheryOptions.build(this.config, this.current, this.values, Number(this.quantity.value), group, preview);
      const message = this.querySelector('.co-message');
      if (built.errors.length) { message.textContent = built.errors.join(' '); return; }
      if (preview) { this.showReview(built); return; }
      this.busy = true; this.add.disabled = true; message.textContent = this.dataset.addingLabel;
      const root = this.dataset.root || '/';
      let inserted = false;
      let parentKey = null;
      try {
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[built.items[0]]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add your configuration.');
        inserted = true;
        parentKey = result.items?.[0]?.key;
        if (!parentKey) throw new Error('Could not identify the configured sofa in the cart.');
        if (built.items.length > 1) {
          const addons = built.items.slice(1).map(item => { const {parent_id, ...child} = item; return {...child,parent_line_key:parentKey}; });
          const addResponse = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:addons})});
          const addResult = await addResponse.json();
          if (!addResponse.ok) throw new Error(addResult.description || addResult.message || 'Could not add the selected upgrades.');
        }
        const cartResponse = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'},cache:'no-store'});
        if (!cartResponse.ok) throw new Error('Please review your cart before trying again.');
        const cart = await cartResponse.json();
        const groupItems = cart.items.filter(item => item.properties?._couchery_config === group);
        const errors = CoucheryOptions.inspectCart({items:groupItems}, {[String(this.config.productId)]:this.config});
        if (groupItems.length !== built.items.length || errors.length) throw new Error('Your configuration needs review in the cart. ' + errors.join(' '));
        location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (inserted && parentKey) {
          try {
            const rollback = await fetch(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parentKey,quantity:0})});
            if (rollback.ok) inserted = false;
          } catch (_) { /* Keep the cart review link if cleanup could not be confirmed. */ }
        }
        message.textContent = error.message;
        if (inserted) {
          const link = document.createElement('a'); link.href = this.dataset.cartUrl; link.textContent = this.dataset.cartLabel || 'Review cart'; message.append(' ',link);
          this.add.disabled = true;
          return;
        }
        this.busy = false; this.add.disabled = false;
      }
    }
    showReview(built) {
      const box = this.querySelector('.co-cart-review'); box.replaceChildren(); box.hidden = false;
      const heading = document.createElement('h3'); heading.textContent = this.dataset.reviewHeading; box.append(heading);
      const row = (label, detail, amount, total = false) => {
        const line = document.createElement('div'); line.className = 'co-cart-line' + (total ? ' co-cart-total' : '');
        const text = document.createElement('span'); text.textContent = label;
        if (detail) { const small = document.createElement('small'); small.textContent = detail; text.append(small); }
        const price = document.createElement('span'); price.textContent = this.money(amount); line.append(text,price); box.append(line);
      };
      const qty = Number(this.quantity.value);
      row(this.dataset.productTitle, this.current.name + ' · ×' + qty, this.current.price * qty);
      for (const {set,choice} of this.configSelection.chosen) row(set.label, choice.label + ' · ×' + qty, (choice.paid ? choice.price : 0) * qty);
      const totalLabel = this.dataset.totalLabel || 'Total'; row(totalLabel,'',built.total,true);
      const note = document.createElement('p'); note.textContent = this.dataset.reviewNote; box.append(note);
      const text = Object.entries(this.configSelection.properties).filter(([key]) => !this.configSelection.chosen.some(({set}) => set.label === key));
      for (const [key,value] of text) { const p = document.createElement('p'); p.textContent = key + ': ' + value; box.append(p); }
      this.querySelector('.co-message').textContent = '';
      this.lastReviewPayload = built;
    }
    renderSwatches() {
      const term = this.search.value.toLocaleLowerCase().trim();
      const all = this.rows.filter(row => row.material === this.current.material);
      if (['Performance Diamond', 'Premium Natural', 'Loft Bouclé', 'Velour Suede', 'Cloudsoft Weave'].includes(this.current.material)) all.sort((a,b) => Number(a.code.replace(/\D/g,'')) - Number(b.code.replace(/\D/g,'')));
      const matches = all.filter(row => (row.colour + ' ' + row.code).toLocaleLowerCase().includes(term));
      this.querySelector('.lf-count').textContent = matches.length + ' / ' + all.length;
      this.querySelector('.lf-empty').hidden = matches.length > 0;
      this.grid.replaceChildren();
      matches.forEach(row => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'lf-swatch'; button.dataset.variantId = row.id;
        button.setAttribute('aria-pressed', String(row.id === this.current.id));
        button.setAttribute('aria-label', row.colour + (row.code ? ' — ' + row.code : ''));
        const image = document.createElement('img');
        if (row.swatch || row.image) { const thumbnail = new URL(row.swatch || row.image, location.origin); thumbnail.searchParams.set('width', '220'); image.src = thumbnail.toString(); }
        image.alt = ''; image.width = 110; image.height = 110; image.loading = 'lazy';
        const label = document.createElement('span'); label.className = 'lf-swatch-name'; label.textContent = row.colour;
        button.append(image, label); button.addEventListener('click', () => this.select(row)); this.grid.append(button);
      });
    }
  });
}







